import {AmbientLight, DirectionalLight, Group, HemisphereLight} from "three";

export default class LightsGroup extends Group{

    ambientLight = new AmbientLight('blue', 100);
    hemiLight = new HemisphereLight( 0xffffff, 0xffffff, 1.0 );
    directLight = new DirectionalLight(0xffffff, 1.3);
    directLightShadows = new DirectionalLight(0xffffff, 0.6);

    constructor() {
        super();

        // this.hemiLight.color.setHSL( 0.6, 1, 0.6 );
        // this.hemiLight.color.setHSL( 0,0,0 );
        // this.hemiLight.color.setRGB(0.9, 1, 0.1)
        this.hemiLight.groundColor.setHSL( 0.095, 1, 0.75 );
        this.hemiLight.position.set( 0, 50, 0 );

        this.directLight.position.set(-50, 200, 100);
        // this.directLight.position.multiplyScalar( 50);
        this.directLight.color.setRGB(0.8, 0.8, 0.6);

        this.directLightShadows.position.set(500, 10, 400);

        this.directLight.name = "dirlight";
        this.directLight.castShadow = true;
        this.directLight.shadow.mapSize.width = 512;
        this.directLight.shadow.mapSize.height = 512;
        this.directLight.shadow.camera.near = 0;
        this.directLight.shadow.camera.far = 1000;
        this.directLight.shadow.bias = 0.0001;

        this.add(this.hemiLight, this.directLight, this.directLightShadows);
    }

}